/**
 * Creates a Redux store listener that triggers a callback
 * when a selected subset of the state changes.
 *
 * @param {Object} store - Redux store
 * @param {function} selector - accepts a state and returns a subset of that state
 * @param {function} callback - called when the selected state changes
 * @returns {function} listener - can be subscribed to a Redux store
 */
export default function createListener (store, selector, callback) {
  let currentState
  return function listener () {
    const previousState = currentState
    currentState = selector(store.getState())
    if (previousState !== currentState) {
      callback(currentState)
    }
  }
}
